/**
 * Éclat Luxury Jewelry - Recently Viewed Tracker
 */
document.addEventListener('DOMContentLoaded', () => {
  const bar = document.getElementById('RecentlyViewedBar');
  const tray = document.getElementById('RecentlyViewedTray');
  const countEl = document.querySelector('[data-rv-count]');
  const grid = document.querySelector('[data-rv-items-grid]');
  const storageKey = 'eclat_recently_viewed';

  function getItems() {
    try {
      return JSON.parse(localStorage.getItem(storageKey)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveItem(product) {
    let items = getItems();
    items = items.filter(i => i.id !== product.id && i.handle !== product.handle);
    items.unshift(product);
    if (items.length > 8) items.pop();
    localStorage.setItem(storageKey, JSON.stringify(items));
    renderBar();
  }

  function renderBar() {
    if (!bar || !grid) return;
    const items = getItems();
    if (items.length === 0) {
      bar.style.display = 'none';
      return;
    }

    bar.style.display = 'block';
    if (countEl) countEl.textContent = items.length;

    grid.innerHTML = items.map(item => `
      <a href="${item.url}" class="rv-card">
        <img src="${item.image}" alt="${item.title}">
        <div class="rv-card-info">
          <h5>${item.title}</h5>
          <span>${item.price}</span>
        </div>
      </a>
    `).join('');
  }

  // If on product page, record product
  const pdpForm = document.getElementById('ProductMainForm');
  if (pdpForm) {
    const titleEl = document.querySelector('.pdp-info__title');
    const priceEl = document.querySelector('.pdp-info__price');
    const imgEl = document.querySelector('.pdp-gallery__main-image');
    if (titleEl && imgEl) {
      saveItem({
        id: window.location.pathname,
        handle: window.location.pathname.split('/').pop(),
        title: titleEl.textContent.trim(),
        price: priceEl ? priceEl.textContent.trim().split('\n')[0] : '',
        image: imgEl.src,
        url: window.location.pathname
      });
    }
  } else {
    renderBar();
  }

  document.querySelectorAll('[data-toggle-recently-viewed]').forEach(b => {
    b.addEventListener('click', () => {
      if (tray) tray.classList.toggle('is-open');
    });
  });
});
